import { formatUTCDate } from 'Common/utilities/date';
import { FULL_TIME_AND_DATE_FORMAT } from 'Common/constants/dateConfigs';

export default class NoteModalCtrl {
  getFormattedDate(date) {
    return formatUTCDate(FULL_TIME_AND_DATE_FORMAT)(date);
  }
}
